import {
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	Output
} from '@angular/core';
import {
	AdminTwoFaUserInfo,
	UserTwoFaAccountInfo
} from '@models/two-fa.models';
import { TwoFaAuthenticationDataService } from '@services/user/two-fa-authentication.data.service';
import { finalize, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { MessageService } from '@services/helpers/message-service/message.service';
import { AdminUsersDataService } from '@web-services/admin/users/admin-users.data.service';
import { SNModalService } from '@web-services/modal/snModal.service';
import { ConfirmGeneralModalComponent } from '@web-components/common/confirm-general-modal/confirm-general-modal.component';

@Component({
	selector: 'two-fa-setup',
	template: require('./manage-user-2fa-modal.html'),
	styles: [require('./manage-user-2fa-modal.scss')]
})
export class ManageUser2faModal implements OnDestroy {
	@Input() twoFaInfo: AdminTwoFaUserInfo;
	@Input() businessAccountId: string;
	@Output() closeModal: EventEmitter<void> = new EventEmitter<void>();

	btnDisable: boolean;
	disabledRowIndex: number;
	private unsubscribe: Subject<void> = new Subject<void>();

	constructor(
		private twoFaAuthenticationDataService: TwoFaAuthenticationDataService,
		private messageService: MessageService,
		private adminUsersDataService: AdminUsersDataService,
		private modalService: SNModalService
	) {}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	onDismiss(): void {
		this.closeModal.emit();
	}

	confirmTwoFaAction(user: UserTwoFaAccountInfo, index: number): void {
		const modal = this.modalService.openModal(ConfirmGeneralModalComponent);

		document.body.classList.remove('modal-open');

		modal.componentInstance.text = `Are you sure you want to turn off two-factor authentication for user ${
			user.email
		}?`;
		modal.componentInstance.buttons = [
			{
				text: 'Yes, turn it off',
				color: 'danger',
				size: 'lg',
				action: 'TURN_OFF_2FA'
			},
			{
				text: 'No, keep it on',
				color: 'success',
				size: 'lg',
				action: 'REJECT_ACTION'
			}
		];

		modal.result.then((state: string): void => {
			document.body.classList.add('modal-open');
			if (state === 'TURN_OFF_2FA') {
				this.switchOff2Fa(user, index);
			}
		});
	}

	private switchOff2Fa(user: UserTwoFaAccountInfo, index: number): void {
		this.btnDisable = true;
		this.disabledRowIndex = index;
		const { url, method } = user.actions.TURN_OFF_2FA;
		this.twoFaAuthenticationDataService
			.send2FAAction(url, method)
			.pipe(
				takeUntil(this.unsubscribe),
				finalize((): void => {
					this.btnDisable = false;
					this.disabledRowIndex = null;
				})
			)
			.subscribe(
				(): void => {
					this.messageService.showToaster('s_6', 'twoFa', user.email);
					this.updateUserTwoFaInfo();
				},
				({ error }): void => {
					const { errorMessage, errorTitle } = error;
					this.messageService.showErrorFromBackend(errorTitle, errorMessage);
				}
			);
	}

	private updateUserTwoFaInfo(): void {
		this.adminUsersDataService
			.getUserTwoFaInfo(this.businessAccountId)
			.pipe(takeUntil(this.unsubscribe))
			.subscribe(
				({ data }): void => {
					if (!data.users.length) {
						this.messageService.showErrorFromBackend(
							'Whooops',
							'Seems like there are no users with 2FA set up on this account'
						);
						this.onDismiss();
						return;
					}
					this.twoFaInfo = data;
				},
				({ error }): void => {
					const { errorTitle, errorMessage } = error;
					this.messageService.showErrorFromBackend(errorTitle, errorMessage);
					this.onDismiss();
				}
			);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/2fa/modals/manage-user-2fa-modal/manage-user-2fa-modal.ts